import { Routes, Route, RouteProps, FunctionComponent, createElement, Navigate} from "external/react"

import Layout from 'layout/index'
import {Page, AdminPage, AccountingPage} from 'pages/index'


const freePaths : Array<RouteProps> = [
	route('/success', Page('Success'))
]

const publicIndex = createElement(Navigate, {to: '/offers'})
const publicPaths: Array<RouteProps> = [
  route('/offers', Page('Offers')),
	route('/offers/:offerId', Page('Offer')),
	route('/subjects/:offerId/:idSelectCourse/:typeSubject', Page('Subjects')),
	route('/courses/:idSubject/:offerId/:idSelectCourse/:typeSubject', Page('Courses')),
	route('/course-detail/:courseId', Page('CourseDetail')),
	route('/summary', Page('Summary'))
]

const parentPaths: Array<RouteProps> = [
	route('/home', Page('Home')),
	route('/home/profile', Page('Profile')),
	route('/home/support', Page('Support')),
	route('/home/packages', Page('Packages')),
	route('/home/packages/:packageId', Page('Package')),
	route('/home/payment', Page('Payment')),
	route('/home/payment/history', Page('PaymentHistory')),
	route('/home/users/:role', Page('Users')),
	route('/home/users/:role/new', Page('NewUser')),
	route('/home/users/:role/packages/:userId', Page('UserPackages')),
]

const parentIndex = createElement(Navigate, {to: '/home'})

const adminPaths: Array<RouteProps> = [
	route('/admin',AdminPage('Home')),
	route('/admin/offers',AdminPage('Offers')),
	route('/admin/offers/configuration/:offerId', AdminPage('OfferConfiguration')),
	route('/admin/clients',AdminPage('Clients')),
	route('/admin/clients/:clientId',AdminPage('Client')),

	route('/admin/packages/details/:purchaseItemId',AdminPage('Home')),
	route('/admin/transactions',AdminPage('Home')),
	route('/admin/transactions/client/:clientId',AdminPage('Home')),
	route('/admin/transactions/history',AdminPage('Home')),
	route('/admin/profile',AdminPage('Home'))
]

const adminIndex = createElement(Navigate, {to: '/admin'})

const accountingPaths: Array<RouteProps> = [
	route('/accounting', AccountingPage('Home')),
	route('/accounting/payouts', AccountingPage('Payouts')),
	route('/accounting/payouts/:payoutId', AccountingPage('Payout')),
	route('/accounting/clients', AccountingPage('Clients')),
	route('/accounting/clients/:clientId',AccountingPage('Client')),
]

const accountingIndex = createElement(Navigate, {to: '/accounting'})

const roleIndexes = {
	'PARENT': parentIndex,
	'ADMIN_HOMESCHOOLER': adminIndex,
	'ACCOUNTING': accountingIndex
}

const roleLayoutNames = {
	'PARENT': 'Parent',
	'ADMIN_HOMESCHOOLER': 'Admin',
	'ACCOUNTING': 'Accounting'
}

export default function createRoutes(role?: string) {

    const publicRoutes = publicPaths.map((props, key) => createElement(Route, {...props, key}))
	publicRoutes.push(createElement(Route, {index: true, element: publicIndex, key: 'index'}))

    const roleRoutes = role ? rolePaths(role).map((props, key) => createElement(Route, {...props, key})) : []
	const layoutRoutes = [createElement(Route, {path: '/', key: 'public', Component: Layout('Public')}, publicRoutes)]

	if (role && roleRoutes.length > 0) {
		const roleIndex = roleIndexes[role]
		const layoutName = roleLayoutNames[role]
		roleRoutes.push(createElement(Route, {index: true, element: roleIndex, key: 'index'}))
		layoutRoutes.push(createElement(Route, {path: '/', key: 'role', Component: Layout(layoutName)}, roleRoutes))
	}
	
	const freeRoutes = freePaths.map((props, key) => createElement(Route, {...props, key}))

    return createElement(Routes, undefined, layoutRoutes.concat(freeRoutes))    
}

function rolePaths (role: string) {
    switch(role) {
        case 'PARENT': return parentPaths
        case 'ADMIN_HOMESCHOOLER': return adminPaths
				case 'ACCOUNTING': return accountingPaths
		default: return []
    }
}


function route(path: string, Component: FunctionComponent, named?: RouteProps): RouteProps {
    const props:RouteProps = {path, Component, ...(named || {exact: true})}
    return props
}